import { SET_LANDING_PAGE_URLS, SET_SUPPORT_INFO } from 'constants/actionTypes';

export const setSupportInfo = (
  {supportEmail, supportPhoneNumber, referrerCountryCode, landingPageUrls}) =>
  ({
    type: SET_SUPPORT_INFO,
    supportEmail,
    supportPhoneNumber,
    referrerCountryCode,
    landingPageUrls
  });

export const setLandingPageUrls = (landingPageUrls) =>
  ({ type: SET_LANDING_PAGE_URLS, landingPageUrls });
